import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { externalServiceLaunched } from '@rikstv/play-common/src/forces/externalService/actions';

import { ProviderVariantExternal } from '../contentStack.types';

export const useOnPlayExternal = (invalidateData: () => void) => {
  const dispatch = useDispatch();
  return useCallback(
    (variant: ProviderVariantExternal) => {
      dispatch(
        externalServiceLaunched({
          reportUrl: variant._links.reportExternalPlayback?.href ?? null,
          serviceId: variant._links.externalPlayback.providerId,
          elementId: variant.tracking.elementId,
          elementName: variant.tracking.elementName,
        })
      );
      window.open(variant._links.externalPlayback.webPlaybackUri, '_blank');
      // refresh data after reporting external service playback
      invalidateData();
    },
    [dispatch, invalidateData]
  );
};
